import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getSubcategary } from "../../redux/categary/action";

export default function CommonSubCategoryCreatable({
  formik,
  prop,
  categoryId,
  selectSubcategory,
  setSelectSubcategory,
}) {
  const dispatch = useDispatch();
  const subcategarylist = useSelector((state) => state.categary.subcategarylist);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (categoryId) {
      dispatch(getSubcategary(categoryId));
    }
  }, [categoryId, dispatch]);

  useEffect(() => {
    if (Array.isArray(subcategarylist)) {
      setOptions(
        subcategarylist.map((item) => ({
          value: item.id,
          label: item.title,
        }))
      );
    } else {
      setOptions([]);
    }
  }, [subcategarylist]);

  const handleChange = (newValue) => {
    setSelectSubcategory(newValue);
    if (newValue) {
      formik.setFieldValue(prop.name, newValue.value);
      formik.setFieldValue("subcategory_index", newValue);
      formik.setFieldValue("sub_category_title", newValue.label);
    } else {
      formik.setFieldValue(prop.name, "");
      formik.setFieldValue("subcategory_index", "");
      formik.setFieldValue("sub_category_title", "");
    }
  };

  return (
    <div className="form-group">
      <label>{prop.title}</label>
      <CreatableSelect
        isClearable
        options={options}
        value={selectSubcategory}
        onChange={handleChange}
        placeholder={prop.placeholder || "Select or Add Sub Category"}
        noOptionsMessage={() => "No subcategories found. Type to add one."}
        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
      />
      <ErrorMessage name={prop.name} component="div" className="error" />
    </div>
  );
}
